export var legacyBlog = {
    slugSegments: ['legacyYear', 'legacyMonth', 'legacyDay', 'slug'],
    basicSlug: '{{slug}}',
    regexes: ['\\d{4}/\\d{2}/{{slug}}', '\\d{4}/\\d{2}/\\d{2}/{{slug}}'],
    mappings: [
        '{{legacyYear}}/{{legacyMonth}}/{{slug}}',
        '{{legacyYear}}/{{legacyMonth}}/{{legacyDay}}/{{slug}}',
    ],
};
//# sourceMappingURL=legacy-mappings.js.map